import { render, staticRenderFns } from "./TaskAssignmentComponent.vue?vue&type=template&id=d689d810&scoped=true"
import script from "./TaskAssignmentComponent.vue?vue&type=script&lang=js"
export * from "./TaskAssignmentComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignmentComponent.vue?vue&type=style&index=0&id=d689d810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d689d810",
  null
  
)

export default component.exports